/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { LayoutState, BannerState } from '../../../../common/types.tsx';

export const showBanner =
	(newState: BannerState): Action<LayoutState> =>
	({ setState }) => {
		setState({
			banner: newState,
		});
	};

export const dismissCurrentBanner =
	(): Action<LayoutState> =>
	({ dispatch }) => {
		dispatch(showBanner({ height: 0, activeBanner: null }));
	};
